var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"games-page"},[_c('div',{staticClass:"hero-section"},[_c('Hero',{attrs:{"heroIcon":_vm.heroIcon}}),_c('h1',{staticClass:"hero-title text-gradient"},[_vm._v("We make the most incredible little worlds!")]),_c('p',{staticClass:"hero-subtitle"},[_vm._v("Explore our collection of amazing games")])],1),_c('GameCardList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }